module.exports = __webpack_public_path__ + "img/filter.99d8d1e4.svg";